import { VoiceModel } from "@/actions/db/get-models";

export const getVoiceModelConvertLink = (model: VoiceModel) => {
  return model.ownerId
    ? window.location.origin + `/convert/${model.ownerId}/${model.name}`
    : window.location.origin + `/convert/${model.name}`;
};
